export const normalizePromotionInfo = (rawData) => {
  if (!rawData) return
  return {
    id: rawData.id,
    title: rawData.title,
    type: rawData.type,
  }
}
